import { actionTypesEnum } from '../enum';

export const getNotaDebitoPorEmisor = (state = null, action) => {

    if (action.type === actionTypesEnum.getNotaDebitoPorEmisor) {
        return action.payload;
    }

    return state;
};
